import { useMemo, memo } from "react";
import { ViewsButton, ViewsButtonType } from "components/buttons/ViewsButton";
import { LikeButton } from "components/buttons/LikeButton";
import { SoundButton } from "components/buttons/SoundButton";
import { QualityButton } from "components/buttons/QualityButton";
import { ShareButton } from "components/buttons/ShareButton";
import { FSButton } from "components/buttons/FSButton";
import { MoreRoundButton } from "components/buttons/MoreRoundButton";
import LiveButton from "components/ads/LiveButton";
import { IGif } from "services/types";
import { MenuShareEvent } from "utils/bus";
import "./Sidebar.scss";

interface ISidebarProps {
  gif: IGif;
  currentUserName: string | undefined;
  liked: boolean;
  likesCount: number;
  fullscreen: boolean;
  gifSound: boolean;
  gifQuality: string;
  onMenu: (options: MenuShareEvent) => void;
  onShare: (options: MenuShareEvent) => void;
  onLike: () => void;
  onFullScreen: () => void;
  onSound: (sound: boolean) => void;
  onQuality: (quality: string) => void;
}

export const Sidebar: React.FC<ISidebarProps> = memo((props) => {
  const {
    gif,
    likesCount,
    liked,
    fullscreen,
    currentUserName,
    gifSound,
    gifQuality,
    onMenu,
    onShare,
    onLike,
    onQuality,
    onSound,
    onFullScreen
  } = props;

  const isCurrentUserImg = useMemo(() =>
    gif.type !== 1 && gif.userName === currentUserName
  , [currentUserName, gif.type, gif.userName]);

  return (
    <ul className="SideBar">
      <li className="SideBar-Item">
        <ViewsButton
          count={gif.views}
          type={gif.type === 1 ? ViewsButtonType.VIDEO : ViewsButtonType.IMAGE}
        />
      </li>
      <li className="SideBar-Item">
        <LikeButton
          liked={liked}
          count={likesCount}
          onClick={onLike}
        />
      </li>
      {gif.hasAudio && (
        <li className="SideBar-Item">
          <SoundButton
            enabled={gifSound}
            onClick={() => onSound(!gifSound)}
          />
        </li>
      )}

      {gif.type === 1 && !fullscreen && (
        <li className="SideBar-Item">
          <QualityButton onChange={onQuality} quality={gifQuality} />
        </li>
      )}

      {isCurrentUserImg && (
        <li className="SideBar-Item">
          <ShareButton onClick={(event) => onShare({ event, gif })} />
        </li>
      )}

      {!isCurrentUserImg && (
        <li className="SideBar-Item">
          <FSButton fullscreen={fullscreen} onClick={onFullScreen} />
        </li>
      )}

      <li className="SideBar-Item">
        <MoreRoundButton onClick={(event) => onMenu({ event, gif })} />
      </li>

      {!fullscreen && (
        <li className="SideBar-Item">
          <LiveButton />
        </li>
      )}
    </ul>
  );
});
